<div
  *ngIf="loadingState$ | async as state"
  [ngClass]="state.isLoading ? 'loading-overlay' : 'd-none'"
>
  <div class="loading-container">
    <div class="loading-content">
      <div class="spinner">
        <div
          class="spinner-border"
          [ngClass]="'text-' + (state.config?.color || 'primary')"
          [attr.aria-label]="state.config?.message || 'Carregando dados'"
        >
          <span class="visually-hidden">{{
            state.config?.message || "Carregando..."
          }}</span>
        </div>
      </div>

      <div class="loading-text">
        <h5 class="mb-2">
          {{ state.config?.message || "Carregando dados..." }}
        </h5>
        <p class="text-muted mb-0" *ngIf="state.config?.description">
          {{ state.config?.description }}
        </p>
        <p class="text-muted mb-0" *ngIf="!state.config?.description">
          Por favor, aguarde um momento
        </p>
      </div>
    </div>
  </div>
</div>
